import React, { createContext, useState, ReactNode } from 'react';
import client from '../api/client';
import showToast from '../components/CustomToast/toastHelper';
import { useNavigate } from 'react-router-dom';

interface UserContextType {
    userDetails: any;
    setUserDetails: (user: any) => void;
    fetchUser:() =>void
}

export const UserContext = createContext<UserContextType | null>(null);
interface UserProviderProps {
    children: ReactNode;
}

export const UserProvider = ({ children }: UserProviderProps) => {
    const [userDetails, setUserDetails] = useState<any>(null);
    const navigate =useNavigate()
    const fetchUser = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/me');
            if (response.data.status === "success") {
                
                setUserDetails(response.data);
                
            } else {
                console.error(response.data.message);
            }
        } catch (err:any) {
            console.log(err);
            console.error("Could not retrieve user details");
            // sessionStorage.removeItem("accessToken")
            // navigate('/login')
            // showToast(err.message, "error");
        }
    };


    return (
        <UserContext.Provider value={{ userDetails, setUserDetails, fetchUser }}>
            {children}
        </UserContext.Provider>
    );
};
